import React from 'react';
import { Loading } from '../loading/Loading';
import { IActionButton } from 'interfaces/actionButton';
import styles from './index.module.scss';

const ActionButton = (props: IActionButton) => {
  const { text, onClick, isLoading, active, customClass, isSubmit } = props;
  return (
    <>
      <button
        type={isSubmit ? 'submit' : 'button'}
        disabled={!active || isLoading}
        className={`${styles['action-btn']} btn ${active ? 'btn-active' : 'btn-disabled'} ${customClass || ''}`}
        onClick={e => {
          e.preventDefault();
          onClick();
        }}
      >
        {isLoading ? <Loading type='mini' /> : text}
      </button>
    </>
  );
};

export default ActionButton;
